import {
    ALGOLIA_APP_ID,
    ALGOLIA_SEARCH_KEY,
    ALGOLIA_INDEX,
    ALGOLIA_INDEX_BY_DATE
} from "./constants";

import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";

// const algoliasearch = require('algoliasearch/lite');
// const instantsearch = require('instantsearch.js').default;

import { configure, hits } from 'instantsearch.js/es/widgets';
import { connectSearchBox } from 'instantsearch.js/es/connectors'

import aa from 'search-insights'
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'

class AlgoliaSearchLight {
    constructor() {
        this.clientId = ALGOLIA_APP_ID;
        this.apiKey = ALGOLIA_SEARCH_KEY;
        this.index = window.search_index || ALGOLIA_INDEX;
        this.indexByDate = window.search_index_date || ALGOLIA_INDEX_BY_DATE;
        this.init();
    }

    init() {
        const $body = $('body');
        this.searchopener = $('.search-opener');
        this.searchwrap   = $('.search-block');
        this.searchResults = document.querySelector('#search-quick-results');
        this.searchResultsSuggested = document.querySelector('#search-quick-results-suggested');
        const searchactive = 'search-active';

        this.searchopener.click((e) => {
            e.preventDefault();
            $body.toggleClass(searchactive);
            if($body.hasClass(searchactive)) {
                if(! this.search.started) {
                    this.search.start();
                }

                setTimeout(() => {
                    document.getElementById('search-quick-input').focus()
                }, 100)
            }
        });
        const buttonAdvancedSearch = document.getElementById('btn-advanced-search');
        const buttonSuggestions = document.querySelectorAll('[data-search-suggestion-quick]');
        const suggestionsList = document.querySelector('.search-suggestion-list');
        Array.from(buttonSuggestions).forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const suggestion = event.target.dataset.searchSuggestionQuick;
                const input = document.getElementById('search-quick-input');
                input.value = suggestion;
                this.search.helper.state.query = suggestion;
                this.search.refresh();
                input.focus();

                if(buttonAdvancedSearch) {
                    buttonAdvancedSearch.setAttribute('href', `${buttonAdvancedSearch.dataset.advancedSearch}?search=${suggestion}`)
                }
            })
        });

        $('html').on('click touchstart pointerdown MSPointerDown', (e) => {
            var target = $(e.target);
            if(!target.closest(this.searchopener).length && !target.closest(this.searchwrap).length) {
                $body.removeClass(searchactive);
            }
        });

        const algoliaClient = algoliasearch(
            this.clientId,
            this.apiKey
        );

        const searchClient = {
            search(requests) {
                const newRequests = requests.map((request)=>{
                    if(!request.params.query || request.params.query.length===0) {
                        request.params.analytics = false
                    }
                    return request
                });

                return algoliaClient.search(newRequests);
            },
        };

        this.search = instantsearch({
            indexName: this.index,
            searchClient: algoliaClient,
            searchFunction: (helper) => {
                const has_query = helper.state.query.length > 0;

                if(helper.state.query.length > 2) {
                    helper.setQueryParameter('optionalFilters', ['is_featured_author:true', 'is_featured:true']);
                } else {
                    helper.setQueryParameter('optionalFilters', ['is_featured:true']);
                }

                if(this.searchResultsSuggested) {
                    if(has_query) {
                        this.searchResults.classList.remove('hide-results')
                        this.searchResultsSuggested.classList.add('hide-results')
                    } else {
                        this.searchResults.classList.add('hide-results')
                        this.searchResultsSuggested.classList.remove('hide-results')
                    }
                } else {
                    this.searchResults.classList.remove('hide-results')
                }
                this.appendPosts = !!(helper.state.query.length < 1 && window.featured_posts_list);
                if(!helper.state.query || helper.state.query.length === 0) {
                    this.search.analytics = false;
                }
                helper.search();
            }
        });

        const renderAuthor = (hit, bindEvent) => {
            return `
                <a href="${ hit.url }" ${ bindEvent('click', hit, 'Quick Search - Click on Author') }>
                <div class="author-card">
                    <strong class="title">
                        ${ hit.title }
                        </strong>
                        <div class="author-avatar"><img src="${ hit.avatar }"/></div>
                    </div>
                </a>
            `
        };

        const renderPost = (hit, bindEvent) => {
            return `
                <a href="${ hit.url }" ${ bindEvent('click', hit, 'Quick Search - Click on Post') }>
                    ${ hit.title }
                    <span class="author">
                        ${ hit.type === 'Podcast' ? '<span class="icon-headphone"></span>' : '' }
                        ${ hit.type === 'Company Announcement' ? '<span class="icon-speaker"></span>' : '' }
                        ${ hit.type === 'Page' ? '' : hit.author }
                    </span>
                </a>
            `
        }

        const renderSearchBox = (renderOptions, isFirstRender) => {
            const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;
            if (isFirstRender) {
                const input = document.createElement('input');
                input.setAttribute('type', 'search');
                input.setAttribute('placeholder', 'Search');
                input.setAttribute('id', 'search-quick-input')

                input.addEventListener('keypress', event => {
                    if(event.key === 'Enter') {
                        if(typeof window.search_page !== 'undefined' && window.search_page.length > 3) {
                            window.location.href = `${window.search_page}?search=${event.target.value}`;
                        }
                    }
                });

                input.addEventListener('input', event => {
                    if(buttonAdvancedSearch) {
                        buttonAdvancedSearch.setAttribute('href', `${buttonAdvancedSearch.dataset.advancedSearch}?search=${event.target.value}`)
                    }
                    refine(event.target.value);
                });

                widgetParams.container.appendChild(input);
            }
        };

        const customSearchBox = connectSearchBox(
            renderSearchBox
        );

        this.search.addWidgets([
            configure({
                hitsPerPage: 5,
                facets: ['is_hidden'],
                facetsRefinements: {
                    'is_hidden': [false],
                }
            }),

            customSearchBox({
                container: document.querySelector('#search-quick-field'),
            }),

            hits({
                container: this.searchResults,

                templates: {
                    item: (hit, bindEvent) => {
                        return hit.is_author ? renderAuthor(hit, bindEvent) : renderPost(hit, bindEvent)
                    },
                    empty(results, { html }) {
                        return html`<p class="search-empty">No results for <b>${results.query}</b></p>`;
                    }
                },

                transformItems: (items) => {
                    if (this.appendPosts) {
                        this.appendPosts = false
                        items = window.featured_posts_list.concat(items)
                    }

                    if(items.length && document.getElementById('search-quick-input').value !== '') {
                        suggestionsList.classList.add('hidden');
                    } else {
                        suggestionsList.classList.remove('hidden');
                    }
                    return items;

                    /*return items.sort((a, b) => {
                        if(a.is_author && b.is_author) {
                            if (a.title > b.title) {
                                return 1;
                            }
                            if (b.title > a.title) {
                                return -1;
                            }
                        }

                        return a.is_author - b.is_author
                    })*/
                }
            }),
        ])

        const insightsMiddleware = createInsightsMiddleware({
            insightsClient: aa,
            insightsInitParams: {
                useCookie: true,
            }
        })

        this.search.use(insightsMiddleware)
    }
}

export default AlgoliaSearchLight
